import type {
  CreateOrganization,
  OrganizationAdminItem,
  UpdateOrganizationLink
} from '@stratumn/studio-shared';
import { action, makeObservable, observable, runInAction } from 'mobx';
import { newError } from '@/services/errors/errors';
import { HTTPWrapper } from '../../utils/http';

export class OrganizationAdminStore {
  organizations: OrganizationAdminItem[] = [];
  loading = false;

  private http = new HTTPWrapper('admin/organizations');

  constructor() {
    makeObservable(this, {
      organizations: observable,
      loading: observable,
      fetchOrganizations: action.bound,
      updateLink: action.bound,
      createOrganization: action.bound
    });
  }

  async fetchOrganizations(options?: { silent?: boolean }): Promise<void> {
    const silent = options?.silent ?? false;
    if (!silent) {
      this.loading = true;
    }
    try {
      const result = await this.http.get<OrganizationAdminItem[]>('');
      runInAction(() => {
        this.organizations = result ?? [];
      });
    } catch (error) {
      throw newError('OrganizationAdmin-fetch', error);
    } finally {
      if (!silent) {
        runInAction(() => {
          this.loading = false;
        });
      }
    }
  }

  async updateLink(rowId: string, dto: UpdateOrganizationLink): Promise<void> {
    try {
      await this.http.patch<{ ok: boolean }, UpdateOrganizationLink>(
        `/${rowId}`,
        dto
      );
      await this.fetchOrganizations({ silent: true });
    } catch (error) {
      throw newError('OrganizationAdmin-update', error);
    }
  }

  async createOrganization(dto: CreateOrganization): Promise<void> {
    try {
      await this.http.post<{ ok: boolean }, CreateOrganization>('', dto);
      await this.fetchOrganizations({ silent: true });
    } catch (error) {
      throw newError('OrganizationAdmin-create', error);
    }
  }
}
